import { useEffect, useRef, useState } from 'react';

const SCRIPT = [
  { type: 'prompt', text: '$ opus scan ./src --check sql-injection' },
  { type: 'think',  text: '  ◆  claude opus 4.6  analyzing codebase...' },
  { type: 'blank',  text: '' },
  { type: 'out',    text: '  Found 4 SQL injection vulnerabilities:' },
  { type: 'blank',  text: '' },
  { type: 'warn',   text: '  ✗  src/api/users/search.js:47' },
  { type: 'warn',   text: '  ✗  src/api/orders/filter.js:112' },
  { type: 'warn',   text: '  ✗  src/services/reports/export.js:89' },
  { type: 'warn',   text: '  ✗  src/db/legacy/queries.js:203' },
  { type: 'blank',  text: '' },
  { type: 'prompt', text: '$ opus ask "create a fix plan for these"' },
  { type: 'think',  text: '  ◆  claude opus 4.6  thinking...' },
  { type: 'blank',  text: '' },
  { type: 'ai',     text: '  1. src/api/users/search.js:47' },
  { type: 'ai',     text: '     → replace string concat with parameterized query' },
  { type: 'ai',     text: '  2. src/api/orders/filter.js:112' },
  { type: 'ai',     text: '     → prepared statement + sanitize special chars' },
  { type: 'ai',     text: '  3. src/services/reports/export.js:89' },
  { type: 'ai',     text: '     → whitelist valid table names, add escape handler' },
  { type: 'ai',     text: '  4. src/db/legacy/queries.js:203' },
  { type: 'ai',     text: '     → migrate to ORM, add input validation layer' },
  { type: 'blank',  text: '' },
  { type: 'prompt', text: '$ seacloud fix --apply-plan --model opus-4.6' },
  { type: 'fix',    text: '  Patching src/api/users/search.js...          ✓' },
  { type: 'fix',    text: '  Patching src/api/orders/filter.js...         ✓' },
  { type: 'fix',    text: '  Patching src/services/reports/export.js...   ✓' },
  { type: 'fix',    text: '  Patching src/db/legacy/queries.js...         ✓' },
  { type: 'blank',  text: '' },
  { type: 'out',    text: '  Re-scan:  0 vulnerabilities found' },
  { type: 'out',    text: '  Tests:    147 passed · 0 failed' },
  { type: 'blank',  text: '' },
  { type: 'prompt', text: '$ seacloud deploy --env prod --cloud azure' },
  { type: 'out',    text: '  Building container image...' },
  { type: 'out',    text: '  Pushing to Azure Container Registry...' },
  { type: 'success',text: '  ✓  live → https://app.client.com  (8m 17s)' },
];

const CHAR_DELAY = 38;
const LOOP_PAUSE = 3200;

const LINE_DELAY = {
  blank:   40,
  think:   100,
  out:     180,
  warn:    150,
  ai:      130,
  fix:     160,
  info:    160,
  success: 180,
};

export default function TerminalWindow() {
  const [shownLines, setShownLines] = useState([]);
  const [typing, setTyping] = useState(null); // { index, chars }
  const timers = useRef([]);
  const bodyRef = useRef(null);

  // Scroll after every render so we always follow the latest output
  useEffect(() => {
    if (bodyRef.current) {
      bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }
  });

  function clear() {
    timers.current.forEach(clearTimeout);
    timers.current = [];
  }

  function run() {
    setShownLines([]);
    setTyping(null);

    let delay = 400;

    for (let i = 0; i < SCRIPT.length; i++) {
      const line = SCRIPT[i];

      if (line.type === 'prompt') {
        const totalTyping = line.text.length * CHAR_DELAY;

        timers.current.push(
          setTimeout((idx) => setTyping({ index: idx, chars: 0 }), delay, i)
        );

        for (let c = 1; c <= line.text.length; c++) {
          timers.current.push(
            setTimeout(
              (chars, idx) => setTyping({ index: idx, chars }),
              delay + c * CHAR_DELAY,
              c,
              i
            )
          );
        }

        delay += totalTyping + 320;

        timers.current.push(
          setTimeout((idx) => {
            setShownLines((prev) => [...prev, idx]);
            setTyping(null);
          }, delay - 150, i)
        );
      } else {
        timers.current.push(
          setTimeout((idx) => {
            setShownLines((prev) => [...prev, idx]);
          }, delay, i)
        );
        delay += LINE_DELAY[line.type] ?? 160;
      }
    }

    timers.current.push(setTimeout(() => run(), delay + LOOP_PAUSE));
  }

  useEffect(() => {
    run();
    return clear;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="terminal-window">
      <div className="terminal-chrome">
        <span className="terminal-dot terminal-dot-red" />
        <span className="terminal-dot terminal-dot-yellow" />
        <span className="terminal-dot terminal-dot-green" />
        <span className="terminal-chrome-title">bash — seacloud</span>
      </div>
      <div className="terminal-body" ref={bodyRef}>
        {SCRIPT.map((line, i) => {
          if (typing && typing.index === i) {
            return (
              <div key={i} className="terminal-line terminal-prompt">
                {line.text.slice(0, typing.chars)}
                <span className="terminal-cursor">▋</span>
              </div>
            );
          }
          if (!shownLines.includes(i)) return null;
          if (line.type === 'blank') return <div key={i} className="terminal-blank" />;
          return (
            <div key={i} className={`terminal-line terminal-${line.type}`}>
              {line.text}
            </div>
          );
        })}
        {shownLines.length === SCRIPT.length && !typing && (
          <div className="terminal-line terminal-prompt">
            <span className="terminal-cursor">▋</span>
          </div>
        )}
      </div>
    </div>
  );
}
